export default (node => {
  return {
    display: node.style.display
  };
});